import { Button } from '@mantine/core';
import { modals } from '@mantine/modals';
import { notifications } from '@mantine/notifications';
import { IconPlus } from '@tabler/icons-react';

import { RouterOutput, trpc } from '../../../../../../services/trpc';
import { TechnicalPlanForm } from './-technical-plan-form';

export function TechnicalPlanButton({
  project,
  label,
  icon = <IconPlus size={16} />,
}: {
  project: NonNullable<RouterOutput['projects']['get']>;
  label: string;
  icon?: React.ReactNode;
}) {
  const generateTechnicalPlan =
    trpc.documents.generateTechnicalPlan.useMutation();

  const openAddTechnicalPlanModal = () => {
    if (!project.availabilityWeek || !project.availabilityYear) {
      window.alert(
        'Veuillez rentrer la date prévue de la marchandise à notre dépôt avant de générer un plan technique.',
      );
      return;
    }

    if (!project.technicalPlanTable) {
      window.alert(
        'Veuillez remplir le tableau avant de générer un plan technique.',
      );
      return;
    }

    modals.open({
      title: 'Ajouter un plan technique',
      size: 'xl',
      closeOnClickOutside: false,
      closeOnEscape: true,
      children: (
        <TechnicalPlanForm
          projectId={project.id}
          onSubmit={async values => {
            await generateTechnicalPlan.mutateAsync({
              projectId: project.id,
              ...values,
            });
            modals.closeAll();
            notifications.show({
              title: 'Plan technique ajouté avec succès',
              message: '',
              color: 'green',
            });
          }}
        />
      ),
    });
  };

  return (
    <Button
      variant="outline"
      leftSection={icon}
      onClick={openAddTechnicalPlanModal}
    >
      {label}
    </Button>
  );
}
